// @flow

import React, { Component } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";

import "./WallSection.scss";

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false
    };
  }

  toggleMenu() {
    this.setState({
      menu: !this.state.menu
    });
  }

  closeMenu() {
    this.setState({
      menu: false
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="foundations_container container row">
          <div className="col-12 container row">
            <div className="col-12 grey-bg">
              <div className="col-4 col-ml-12">
                <div className="description-background">
                  <p className="text-basic">
                    Cały fundament przed zasypaniem należy zabezpieczyć folią
                    kubełkową. Folia kubełkowa doskonale chroni i izoluje
                    podziemne części fundamentów, warstwy hydro i termoizolacji.
                    Wytłoczenia folii umożliwiają odparowanie wilgoci z
                    powierzchni izolowanych fundamentów. Dodatkowo stanowi ona
                    doskonałe zabezpieczenie przed uszkodzeniami mechanicznymi
                    podczas zasypywania wykopów oraz zabezpiecza izolację oraz
                    przed osiadaniem ziemi.
                  </p>
                </div>
              </div>
              <div className="col-4 col-ml-6 col-s-12">
                <img src="/img/przekroj.jpg" className="section-photo" />
              </div>
              <div className="col-4 col-ml-6 col-s-12">
                <ul className="desc-list">
                  <li>
                    <span className="list-number"></span>
                    Ława fundamentowa
                  </li>
                  <li>
                    <span className="list-number"></span>
                    Izolacja pozioma - papa MATIZOL
                  </li>
                  <li>
                    <span className="list-number"></span>
                    Ściana fundamentowa
                  </li>
                  <li>
                    <span className="list-number"></span>
                    Warstwa gruntująca - Szybki Grunt Evomer
                  </li>
                  <li>
                    <span className="list-number"></span>
                    Faseta - Masa Szpachlowa Evomer
                  </li>
                  <li>
                    <span className="list-number"></span>
                    Pierwsza warstwa hydroizolacyjna - Szybka Powłoka Evomer
                  </li>
                  <li>
                    <span className="list-number"></span>
                    Druga warstwa hydroizolacyjna - Szybka Powłoka Evomer
                  </li>
                  <li>
                    <span className="list-number"></span>
                    Termoizolacja klejona za pomocą Kleju do płyt XPS
                  </li>
                  <li>
                    <span className="list-number"></span>
                    Folia kubełkowa Tytan Professional
                  </li>
                  <li>
                    <span className="list-number"></span>
                    Izolacja pozioma - papa MATIZOL lub folia do izolacji
                    poziomej TYTAN Professional
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WallSection/WallSection.js